import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import PayCashDues from "../../../components/AssociationAdmin/Dues/PayCashDues";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Pagination } from "@mui/material";
import "../../AssociationAdmin/Dues/ManageMember.css"
import Loader from "../../../components/utilities/Loader/Loader";
import useAuth from "../../../hooks/useAuthContext";
import Pusher from 'pusher-js';
import PaymentAccountInfo from "../../../components/Member/PaymentAccountInfo";

const MemberDuesPage = () => {
  const appKey =  process.env.NODE_ENV !== 'production' ? 
            process.env.REACT_APP_DEV_PUSHER_KEY :
                process.env.REACT_APP_PROD_PUSHER_KEY

  const appCluster =  process.env.NODE_ENV !== 'production' ? 
                            process.env.REACT_APP_DEV_PUSHER_CLUSTER :
                                process.env.REACT_APP_PROD_PUSHER_CLUSTER
                                

  const { userData } = useAuth();
  const { associationId } = useParams();

  const [memberId, setMemberId] = useState(null)
  const [loading, setLoading] = useState(false);
  const [accountLoading, setAccountLoading] = useState(false);
  const [memberBill, setMemberBill] = useState([]);
  const [memberInfo, setMemberInfo] = useState(null);
  const [memberAccountInfo, setMemberAccountInfo] = useState(null);
  const [payCashOpen, setPayCashOpen] = useState(false);
  const [totalUnpaid, setTotalUnpaid] = useState(0);
  const [transactionCharge, setTransactionCharge] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [filter, setFilter] = useState({
    search: "",
    payStatus: "",
    paginated: true,
  });
  
  //  state for pagination
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(1);

  //  pagination function
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilter((prevFilter) => ({ ...prevFilter, [name]: value }));
  };

  const handleSelectAll = (event) => {
    setSelectAll(event.target.checked);
    setSelectedRows(event.target.checked ? memberBill.filter((bill) => bill.status === 'pending').map((bill) => bill.id) : []);
    setShowSubmit(event.target.checked);
  };

  const handleRowSelect = (event, id) => {
    const isChecked = event.target.checked;
    let newSelectedRows = [...selectedRows];

    if (isChecked) {
      newSelectedRows.push(id);
    } else {
      newSelectedRows = newSelectedRows.filter((rowId) => rowId !== id);
    }

    setSelectedRows(newSelectedRows);
    setSelectAll(newSelectedRows.length === memberBill.length); // Update selectAll
    setShowSubmit(newSelectedRows.length > 0);
  };

  const fetchMemberBills = (id) => {
    setLoading(true);
    axiosInstance
      .post(`/association/dues/member/bill/${id}?page=${page}`, filter)
      .then((response) => {
        setMemberBill(response.data.data.data);
        setMemberInfo(response.data.memberInfo);
        setTotalUnpaid(response.data.totalUnpaid)
        setTransactionCharge(response.data.transactionCharge)
        const pageCount = Math.ceil(
          response.data.data.total / response.data.data.per_page
        );
        setPageCount(pageCount);
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  const fetchMemberAccountInfo = (id) => {
    setAccountLoading(true);
    axiosInstance
      .get(`/association/dues/member/bill/fetch_account/${id}`)
      .then((response) => {
        setMemberAccountInfo(response.data.data);
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setAccountLoading(false));
  };

  const handleSubmit = () => {
    setPayCashOpen(true)
  }

  const reload = () => {
    fetchMemberBills(memberId)
    fetchMemberAccountInfo(memberId)
    setSelectedRows([])
    setShowSubmit(false)
  }

  useEffect(() => {
    const currentMembership = userData.userInfo.membership.filter(e => e.association_id == associationId)
    
    setMemberId(currentMembership[0].id)
  }, [associationId])

  useEffect(() => {
    if(memberId) {
        fetchMemberBills(memberId)
        fetchMemberAccountInfo(memberId)
    }
  }, [memberId, filter])


  useEffect(() => {
      const pusher = new Pusher(appKey, {
        cluster: appCluster, // If applicable
      });
  
      const channel = pusher.subscribe('payment-successful'); // Subscribe to your custom channel
      
  
      channel.bind('payment.successful', (data) => { // Listen for the custom event
        const currentMembership = userData.userInfo.membership.filter(e => e.association_id == associationId)

        if(currentMembership[0].id == data.payment.customer.metadata.membership_id) {
          setMemberId(currentMembership[0].id)
  
          toast.success('Payment Successful');

          setPayCashOpen(false)

          fetchMemberBills(data.payment.customer.metadata.membership_id)
          fetchMemberAccountInfo(data.payment.customer.metadata.membership_id)
        }
    
      });
  
      return () => {
        pusher.disconnect(); // Disconnect on component unmount
      };
  }, []);

  return (
    <>
      {/* <!-- start page title --> */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Dues</h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/app">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Dues</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-xl-4 order-sm-first order-lg-last">
            {memberAccountInfo ?
                <div className="sticky-side-div">
                    <PaymentAccountInfo memberAccountInfo={memberAccountInfo} />
                    <div className="card">
                        <div className="card-header border-bottom-dashed">
                            <h5 className="card-title mb-0">Bill Summary</h5>
                        </div>
                        {/* <div className="card-header bg-light-subtle border-bottom-dashed">
                            <div className="text-center">
                                <h6 className="mb-2">Have a <span className="fw-semibold">promo</span> code ?</h6>
                            </div>
                            <div className="hstack gap-3 px-3 mx-n3">
                                <input className="form-control me-auto" type="text" placeholder="Enter coupon code" aria-label="Add Promo Code here..." />
                                <button type="button" className="btn btn-success w-xs">Apply</button>
                            </div>
                        </div> */}
                        <div className="card-body pt-2">
                            <div className="table-responsive">
                                <table className="table table-borderless mb-0">
                                    <tbody>
                                        <tr>
                                            <td>Total Unpaid:</td>
                                            <td className="text-end" id="cart-subtotal">₦{Number(totalUnpaid).toLocaleString()}</td>
                                        </tr>
                                        {totalUnpaid > 0 && ( <tr>
                                            <td>Transaction Charge:</td>
                                            <td className="text-end" id="cart-subtotal">₦{Number(transactionCharge).toLocaleString()}</td>
                                        </tr>)}
                                        <tr>
                                            <td>Virtual Account Balance :</td>
                                            <td className="text-end" id="cart-shipping">₦{Number(memberAccountInfo?.balance).toLocaleString()}</td>
                                        </tr>
                                        <tr className="table-active">
                                            <th>TO PAY:</th>
                                            <td className="text-end">
                                                <span className="fw-semibold" id="cart-total">
                                                    {totalUnpaid == 0 ?
                                                        <h4 className="mb-0 text-danger"><b>NILL</b></h4>
                                                    :
                                                        <h4 className="mb-0 text-danger"><b>₦{Number((Number(totalUnpaid) + Number(transactionCharge)) - Number(memberAccountInfo?.balance)).toLocaleString()}</b></h4>
                                                    }
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* <!-- end table-responsive --> */}
                        </div>
                    </div>
                </div>

            :
                <div className="alert alert-danger border-dashed text-center p-5">
                    <h5>No Virtual Account Created</h5>
                </div>
            }
            {accountLoading && <Loader />}
        </div>
        <div className="col-xl-8 order-sm-last order-lg-first">
          <div className="card" id="invoiceList">
            <div className="card-header border-0">
              <div className="d-flex align-items-center">
                <h5 className="card-title mb-0 flex-grow-1">
                  <b className="text-success font-weight-bolder">
                    {memberInfo?.user?.title} {memberInfo?.user?.last_name} {memberInfo?.user?.first_name} {memberInfo?.user?.middle_name}
                  </b>{" "}
                </h5>
               {showSubmit && <div className="flex-shrink-0">
                    <div className="d-flex gap-2 flex-wrap">
                        <button onClick={handleSubmit} className="btn btn-danger"><i className="ri-refund-2-line align-bottom me-1"></i> Pay Now</button>
                    </div>
                </div>}
              </div>
            </div>
            <div className="card-body bg-light-subtle border border-dashed border-start-0 border-end-0">
              <form>
                <div className="row g-3">
                  <div className="col-xxl-4 col-sm-12">
                    <div className="input-light">
                        <select
                            className="form-control"
                            name="payStatus"
                            value={filter.payStatus}
                            onChange={handleFilterChange}
                        >
                            <option value="">--Payment Status--</option>
                            <option value="pending">Pending</option>
                            <option value="paid">Paid</option>
                        </select>
                    </div>
                  </div>
                  <div className="col-xxl-4 col-sm-12">
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search bg-light border-light"
                        placeholder="Search for dues..."
                        name="search"
                        value={filter.search}
                        onChange={handleFilterChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  {/* <!--end col--> */}
                  {/* <div className="col-xxl-2 col-sm-4">
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={() => fetchMemberBills(memberId)}
                    >
                      <i className="ri-equalizer-fill me-1 align-bottom"></i>{" "}
                      Filters
                    </button>
                  </div> */}
                  {/* <!--end col--> */}
                </div>
                {/* <!--end row--> */}
              </form>
            </div>
            <div className="card-body">
              <div>
                <div className="alert alert-info">
                  <h6 className="mb-0 font-weight-bold">Kindly use the checkbox to select the dues you wish to pay for</h6>
                </div>
                <div className="table-responsive table-card">
                    {memberBill.length > 0 && (
                        <>
                            <table
                                className="table align-middle table-nowrap"
                                id="invoiceTable"
                            >
                                <thead className="text-muted">
                                <tr>
                                  <th scope="col" style={{ width: "50px" }}>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={selectAll} 
                                        onChange={handleSelectAll}
                                      />
                                    </div>
                                  </th>
                                    {/* <th
                                    className="sort text-uppercase"
                                    data-sort="invoice_id"
                                    >
                                    #
                                    </th> */}
                                    <th
                                    className="sort text-uppercase"
                                    data-sort="invoice_id"
                                    >
                                    Due
                                    </th>
                                    <th
                                    className="sort text-uppercase"
                                    data-sort="customer_name"
                                    >
                                    Type
                                    </th>
                                    <th className="sort text-uppercase" data-sort="email">
                                    Amount
                                    </th>
                                    <th className="sort text-uppercase" data-sort="status">
                                    Payment Status
                                    </th>
                                    <th className="sort text-uppercase" data-sort="date">
                                    Date Paid
                                    </th>
                                </tr>
                                </thead>
                                <tbody
                                    className="list form-check-all"
                                    id="invoice-list-data"
                                >
                                    {memberBill.map((bill, i) => (
                                        <tr key={bill.id}>
                                            <th scope="row">
                                              {bill?.status == 'pending' && <div className="form-check">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  checked={selectedRows.includes(bill.id)}
                                                  onChange={(event) => handleRowSelect(event, bill.id)}
                                                />
                                              </div>}
                                            </th>
                                            {/* <td>{i + 1}</td> */}
                                            <td className="id">
                                            <a
                                                href="javascript:void(0);"
                                                data-id="25000351"
                                                className="fw-medium link-primary"
                                            >
                                                {bill?.association_dues?.name}
                                            </a>
                                            </td>
                                            <td className="email">
                                                <span 
                                                    className={`badge ${bill?.association_dues?.type == 'one_off' ? 'bg-warning text-dark': 
                                                        'bg-dark'} text-uppercase`}
                                                >
                                                    {bill?.association_dues?.type}
                                                </span>
                                            </td>
                                            <td className="country">₦{Number(bill?.association_dues?.amount).toLocaleString()}</td>
                                            <td className="status">
                                            <span 
                                                className={`badge ${bill?.status == 'paid' ? 'bg-success-subtle text-success' : 
                                                    'bg-warning-subtle text-warning'} text-uppercase`}
                                            >
                                                {bill?.status}
                                            </span>
                                            </td>
                                            <td className="date">
                                                {bill?.status == 'paid' ? bill?.date_paid : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                                {/* <div className="col-sm-6">
                                                    <div>
                                                        <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">1</span> to <span className="fw-semibold">10</span> of <span className="fw-semibold text-decoration-underline">12</span> entries</p>
                                                    </div>
                                                </div> */}
                                {/* <!-- end col --> */}
                                <div className="col-sm-12 d-flex justify-content-end mt-4">
                                    <Pagination
                                        onChange={handlePageChange}
                                        count={pageCount}
                                        color="primary"
                                        shape="rounded"
                                        size="small"
                                        page={page}
                                    />
                                </div>
                                {/* <!-- end col --> */}
                            </div>
                        </>
                    )}
                    {memberBill.length == 0 && (
                        <div className="noresult">
                        <div className="text-center">
                            <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#405189,secondary:#0ab39c"
                            style={{ width: "75px", height: "75px" }}
                            ></lord-icon>
                            <h5 className="mt-2">Sorry! No Result Found</h5>
                            {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                        </div>
                        </div>
                    )}
                </div>
                
              </div>
            </div>
          </div>
          {loading && <Loader />}
        </div>
      </div>

      {/* Pay Cash Dues Modal */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={payCashOpen}
        onHide={() => setPayCashOpen(false)}
      >
        <Modal.Header closeButton className="bg-light p-3">
          <Modal.Title id="contained-modal-title-vcenter">
            Make Payment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PayCashDues 
            memberId={memberId}
            selectedDues={selectedRows}
            allDues={memberBill}
            close={() => setPayCashOpen(false)} 
            memberAccountInfo={memberAccountInfo}
            transactionCharge={transactionCharge}
            refresh={reload}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MemberDuesPage;
